<template>
  <CardContent
    is="section"
    :class="[size, { 'controls-added': showControls }]"
    theme="neutral-50"
    stroke="l"
    class="card"
  >
    <template #header>
      <div v-if="showControls" class="controls">
        <button
          type="button"
          class="button-close"
          aria-label="close"
          @click="handleClickClose"
        >
          <icon name="closeSmall" size="2.4rem" />
        </button>
      </div>
      <slot name="header"></slot>
    </template>
    <slot />
  </CardContent>
</template>
<script setup lang="ts">
interface Props {
  size?: 'small' | 'medium' | 'large';
  showControls?: boolean;
}
defineProps({
  size: { default: 'medium' },
  showControls: { type: Boolean, default: false }
});
const emit = defineEmits(["close"]);
const handleClickClose = () => {
  emit('close');
};
</script>
<style lang="scss" scoped>
.card {
  display: grid;
  position: relative;
  grid-template-columns: 1fr;
  width: 100%;
  width: calc(100vw - 4rem);
  width: calc(100dvw - 4rem);
  min-width: 46rem;
  min-width: auto;
  box-shadow: rgb(100 100 111 / 20%) 0 7px 29px 0;
  @include above('s') {
    &.small {
      min-width: 36rem;
      max-width: 36rem;
    }
    &.medium {
      max-width: 46rem;
    }
    &.large {
      max-width: var(--content_width);
    }
  }
  &.controls-added {
    padding-top: 2rem;
  }
}

.controls {
  display: flex;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  flex-direction: row-reverse;
  width: 100%;
}

.button-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.8rem;
  height: 1.8rem;
  overflow: hidden;
  transform: translate(0, 0);
  transition: transform 500ms $ease-out-quad, box-shadow 200ms $ease-in-quad;
  border-radius: 50%;
  background-color: var(--color_error);
  color: var(--color_neutral_25);
  &:hover,
  &:focus {
    transform: rotate(180deg);
  }
}
</style>
